export default __webpack_public_path__ + "static/media/st_goEnable.4535cbc2.jpg";